<template>
  <div>
    <label for="manufacturer">Manufacturer</label>
    <select name="manufacturer" v-model="manufacturerIndex">
      <option v-for="(manufacturer, index) in carapaceTypes" :value="index" :key="index">{{ manufacturer.name }}</option>
    </select>
    <label for="model">Model</label>
    <select name="model" v-model="modelIndex">
      <option v-for="(model, index) in localManufacturer.models" :value="index" :key="index">{{ model.name }}</option>
    </select>
    <label for="designation">Designation</label>
    <select name="designation" v-model="designationIndex">
      <option v-for="(designation, index) in localModel.designations" :value="index" :key="index">{{ designation.name }}</option>
    </select>
    <label for="nickname">Nickname</label>
    <input id="nickname" v-model="nickname">
    <p>{{ carapaceFormatted }}</p>
    <button @click="saveCarapaceSettings" :disabled="!nickname">Save</button>
    <hr>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'pilot-settings',
  data() {
    return {
      nickname: '',
      manufacturerIndex: 0,
      modelIndex: 0,
      designationIndex: 0,
    }
  },
  watch: {
    manufacturerIndex() {
      this.modelIndex = 0;
      this.designationIndex = 0;
    },
    modelIndex() {
      this.designationIndex = 0;
    },
  },
  computed: {
    carapaceFormatted() {
      return `${this.localManufacturer.name} // ${this.localModel.name} // ${this.localDesignation.name} // [${this.nickname.toUpperCase()}]`;
    },
    localManufacturer() {
      return this.carapaceTypes[this.manufacturerIndex];
    },
    localModel() {
      return this.localManufacturer.models[this.modelIndex];
    },
    localDesignation() {
      return this.localModel.designations[this.designationIndex];
    },
    ...mapState({
      playerDetails: state => state.playerDetails,
      carapaceTypes: state => state.carapaceTypes,
    }),
  },
  methods: {
    saveCarapaceSettings() {
      this.setCarapaceDetails({
        manufacturerIndex: this.manufacturerIndex,
        modelIndex: this.modelIndex,
        designationIndex: this.designationIndex,
        nickname: this.nickname,
      })
      this.saveState();
      if (this.$route.name === 'setup') {
        this.$emit('carapaceEntered');
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: 'smooth',
          });
        }, 50);
      }
    },
    ...mapMutations([
      'setCarapaceDetails',
      'saveState',
    ]),
  },
  mounted() {
    this.manufacturerIndex = this.playerDetails.carapace.manufacturerIndex;
    this.modelIndex = this.playerDetails.carapace.modelIndex;
    this.designationIndex = this.playerDetails.carapace.designationIndex;
    this.nickname = this.playerDetails.carapace.nickname;
  },
}
</script>

<style scoped>

#nickname {
  text-transform: uppercase;
}
</style>
